/**
 * Gully Labs — Size Selector + Size Guide (Helium PDP)
 */
(function () {
  'use strict';

  /*
    Source: "Size Chart - All shoe - 20 Feb 2026.xlsx", sheet "20 feb 2026".
    Products are mapped to these chart keys in product-variant-picker-gl.liquid.
  */
  var CHARTS = {
    gl001: {
      men: [
        { uk: 6, eu: 40, us: 7, cm: 26.1 },
        { uk: 7, eu: 41, us: 8, cm: 26.7 },
        { uk: 8, eu: 42, us: 9, cm: 27.5 },
        { uk: 9, eu: 43, us: 10, cm: 28.1 },
        { uk: 10, eu: 44, us: 11, cm: 28.8 },
        { uk: 11, eu: 45, us: 12, cm: 29.5 },
        { uk: 12, eu: 46, us: 13, cm: 30.1 }
      ],
      women: [
        { uk: 3, eu: 35, us: 5, cm: 23.7 },
        { uk: 4, eu: 37, us: 6, cm: 24.3 },
        { uk: 5, eu: 38, us: 7, cm: 25.0 },
        { uk: 6, eu: 39, us: 8, cm: 25.7 },
        { uk: 7, eu: 40, us: 9.5, cm: 26.3 },
        { uk: 8, eu: 41, us: 10.5, cm: 27.0 }
      ]
    },
    yatin: {
      men: [
        { uk: 6, eu: 40, us: 7, cm: 26.0 },
        { uk: 7, eu: 41, us: 8, cm: 26.6 },
        { uk: 8, eu: 42, us: 9, cm: 27.2 },
        { uk: 9, eu: 43, us: 10, cm: 27.8 },
        { uk: 10, eu: 44, us: 11, cm: 28.4 },
        { uk: 11, eu: 45, us: 12, cm: 29.0 },
        { uk: 12, eu: 46, us: 13, cm: 29.6 }
      ],
      women: [
        { uk: 3, eu: 36, us: 5, cm: 22.8 },
        { uk: 4, eu: 37, us: 6, cm: 23.4 },
        { uk: 5, eu: 38, us: 7, cm: 24.0 },
        { uk: 6, eu: 39, us: 8, cm: null },
        { uk: 7, eu: 40, us: 9.5, cm: null },
        { uk: 8, eu: 41, us: 10.5, cm: null }
      ]
    },
    gl002: {
      men: [
        { uk: 6, eu: 40, us: 7, cm: 26.7 },
        { uk: 7, eu: 41, us: 8, cm: 27.4 },
        { uk: 8, eu: 42, us: 9, cm: 28.0 },
        { uk: 9, eu: 43, us: 10, cm: 28.7 },
        { uk: 10, eu: 44, us: 11, cm: 29.4 },
        { uk: 11, eu: 45, us: 12, cm: 30.0 },
        { uk: 12, eu: 46, us: 13, cm: 30.7 },
        { uk: 13, eu: 47, us: 14, cm: 31.3 }
      ],
      women: [
        { uk: 3, eu: 36, us: 5, cm: 23.8 },
        { uk: 4, eu: 37, us: 6, cm: 24.5 },
        { uk: 5, eu: 38, us: 7, cm: 25.2 },
        { uk: 6, eu: 39, us: 8, cm: 25.8 },
        { uk: 7, eu: 40, us: 9.5, cm: 26.5 },
        { uk: 8, eu: 41, us: 10.5, cm: 27.1 }
      ]
    },
    gl003: {
      men: [
        { uk: 6, eu: 40, us: 7, cm: 26.7 },
        { uk: 7, eu: 41, us: 8, cm: 27.4 },
        { uk: 8, eu: 42, us: 9, cm: 28.0 },
        { uk: 9, eu: 43, us: 10, cm: 28.7 },
        { uk: 10, eu: 44, us: 11, cm: 29.4 },
        { uk: 11, eu: 45, us: 12, cm: 30.0 },
        { uk: 12, eu: 46, us: 13, cm: 30.7 },
        { uk: 13, eu: 47, us: 14, cm: null }
      ],
      women: [
        { uk: 3, eu: 36, us: 5, cm: 23.8 },
        { uk: 4, eu: 37, us: 6, cm: 24.5 },
        { uk: 5, eu: 38, us: 7, cm: 25.2 },
        { uk: 6, eu: 39, us: 8, cm: 25.8 },
        { uk: 7, eu: 40, us: 9.5, cm: 26.5 },
        { uk: 8, eu: 41, us: 10.5, cm: 27.1 }
      ]
    },
    gl004: {
      men: [
        { uk: 6, eu: 40, us: 7, cm: 26.5 },
        { uk: 7, eu: 41, us: 8, cm: 27.2 },
        { uk: 8, eu: 42, us: 9, cm: 27.9 },
        { uk: 9, eu: 43, us: 10, cm: 28.5 },
        { uk: 10, eu: 44, us: 11, cm: 29.1 },
        { uk: 11, eu: 45, us: 12, cm: 29.8 },
        { uk: 12, eu: 46, us: 13, cm: 30.5 }
      ],
      women: [
        { uk: 3, eu: 36, us: 5, cm: 23.8 },
        { uk: 4, eu: 37, us: 6, cm: 24.5 },
        { uk: 5, eu: 38, us: 7, cm: 25.1 },
        { uk: 6, eu: 39, us: 8, cm: 25.7 },
        { uk: 7, eu: 40, us: 9.5, cm: 26.4 },
        { uk: 8, eu: 41, us: 10.5, cm: 27.1 }
      ]
    },
    gl005: {
      men: [
        { uk: 6, eu: 40, us: 7, cm: 26.1 },
        { uk: 7, eu: 41, us: 8, cm: 26.7 },
        { uk: 8, eu: 42, us: 9, cm: 27.5 },
        { uk: 9, eu: 43, us: 10, cm: 28.1 },
        { uk: 10, eu: 44, us: 11, cm: 28.8 },
        { uk: 11, eu: 45, us: 12, cm: 29.5 },
        { uk: 12, eu: 46, us: 13, cm: 30.1 }
      ],
      women: [
        { uk: 3, eu: 36, us: 4, cm: 23.7 },
        { uk: 4, eu: 37, us: 5, cm: 24.3 },
        { uk: 5, eu: 38, us: 6, cm: 25.0 },
        { uk: 6, eu: 39, us: 7, cm: 25.7 },
        { uk: 7, eu: 40, us: 8, cm: 26.3 },
        { uk: 8, eu: 41, us: 9, cm: 27.0 }
      ]
    }
  };

  /*
    How a familiar size maps onto this product.
    Women and unisex pieces only. Men's charts never show these lines.
  */
  var FIT_ADVICE = {
    "Kara Utility Shacket": "Standard L? → Size S",
    "Kara Workwear Shirt": "Standard L? → Size S",
    "Kara Toggle Shacket": "L → M for comfort | S for snug fit",
    "Kara Cross Collar Shirt": "Standard L? → Size M",
    "Kara Pintuck Women Pant": "32 waist? → Size 34",
    "Gully 17": "For a baggy, low-waist fit → Size up"
  };

  /*
    Body measurements that suit each Kara product.
    Source: Gully Labs body size charts by product.
    Tops: body chest and waist. Bottoms: body waist, hip, and thigh.
  */
  var BODY_CHARTS = {
    "Kara Toggle Shacket": [
      ["Body chest", ["38", "40", "42", "44", "46"]],
      ["Body waist", ["38", "40", "42", "44", "46"]]
    ],
    "Kara Utility Shacket": [
      ["Body chest", ["38", "40", "42", "44", "46"]],
      ["Body waist", ["38", "40", "42", "44", "46"]]
    ],
    "Kara Cross Collar Shirt": [
      ["Body chest", ["36", "38", "40", "42", "44"]],
      ["Body waist", ["36", "38", "40", "42", "44"]]
    ],
    "Kara Workwear Shirt": [
      ["Body chest", ["37", "39", "41", "43", "45"]],
      ["Body waist", ["37", "39", "41", "43", "45"]]
    ],
    "Kara Deconstructed Shirt": [
      ["Body chest", ["37", "39", "41", "43", "45"]],
      ["Body waist", ["37", "39", "41", "43", "45"]]
    ],
    "Kara Saddle Stitch Shirt": [
      ["Body chest", ["38", "40", "42", "44", "46"]],
      ["Body waist", ["38", "40", "42", "44", "46"]]
    ],
    "Kara Pleat Men Trouser": [
      ["Body waist", ["24", "28", "30", "32", "34"]],
      ["Body hip", ["36", "38", "40", "42", "44"]],
      ["Body thigh", ["24", "25", "26", "27", "28"]]
    ],
    "Kara Pleat Women Trouser": [
      ["Body waist", ["26", "28", "30", "32", "34"]],
      ["Body hip", ["37", "39", "41", "43", "45"]],
      ["Body thigh", ["25.5", "26.5", "27.5", "28.5", "29.5"]]
    ],
    "Kara Pintuck Women Pant": [
      ["Body waist", ["26", "28", "30", "32", "34"]],
      ["Body hip", ["38", "40", "42", "44", "46"]],
      ["Body thigh", ["25", "26", "27", "28", "29"]]
    ],
    "Kara Pintuck Men Pant": [
      ["Body waist", ["26", "28", "30", "32", "34"]],
      ["Body hip", ["36", "38", "40", "42", "44"]],
      ["Body thigh", ["24", "25", "26", "27", "28"]]
    ]
  };

  var CHART_ID_NAMES = {
    "kara-pintuck-men-pant": "Kara Pintuck Men Pant",
    "kara-pintuck-women-pant": "Kara Pintuck Women Pant",
    "kara-workwear-shirt": "Kara Workwear Shirt",
    "kara-pleat-men-trouser": "Kara Pleat Men Trouser",
    "kara-utility-shacket": "Kara Utility Shacket",
    "kara-cross-collar-shirt": "Kara Cross Collar Shirt",
    "kara-pleat-women-trouser": "Kara Pleat Women Trouser",
    "kara-deconstructed-shirt": "Kara Deconstructed Shirt",
    "kara-saddle-stitch-shirt": "Kara Saddle Stitch Shirt",
    "kara-toggle-shacket": "Kara Toggle Shacket"
  };

  var PIECE_BY_CATEGORY = {
    shirt: "kara-workwear-shirt",
    shacket: "kara-utility-shacket",
    trouser: "kara-pleat-men-trouser",
    ALL: "kara-workwear-shirt"
  };

  function karaCharts() {
    if (window.__GL_KARA_CHARTS) return window.__GL_KARA_CHARTS;
    var el = document.getElementById('GlKaraCharts');
    window.__GL_KARA_CHARTS = [];
    if (el) {
      try {
        window.__GL_KARA_CHARTS = JSON.parse(el.textContent);
      } catch (err) {
        window.__GL_KARA_CHARTS = [];
      }
    }
    return window.__GL_KARA_CHARTS;
  }

  function apparelPageById(id) {
    var items = karaCharts();
    for (var i = 0; i < items.length; i++) {
      if (items[i].id === id) return items[i];
    }
    return null;
  }

  function canonicalProductName(label, chartId) {
    if (chartId && CHART_ID_NAMES[chartId]) return CHART_ID_NAMES[chartId];
    var text = (label || '').trim();
    if (!text) return '';
    if (CHART_ID_NAMES[text]) return CHART_ID_NAMES[text];
    var names = Object.keys(BODY_CHARTS);
    var lower = text.toLowerCase();
    for (var i = 0; i < names.length; i++) {
      if (lower.indexOf(names[i].toLowerCase()) !== -1) return names[i];
    }
    var fitNames = Object.keys(FIT_ADVICE);
    for (var f = 0; f < fitNames.length; f++) {
      if (lower.indexOf(fitNames[f].toLowerCase()) !== -1) return fitNames[f];
    }
    return text;
  }

  function formatLength(cm, unit) {
    if (cm === null || typeof cm === 'undefined' || cm === 'NA') return 'NA';
    return unit === 'cm' ? Number(cm).toFixed(1) : (Number(cm) / 2.54).toFixed(1);
  }

  function initGuide(root) {
    if (!root || root.dataset.glSgReady) return;
    root.dataset.glSgReady = '1';

    var state = {
      gender: root.getAttribute('data-default-gender') || 'men',
      unit: root.getAttribute('data-default-unit') || 'cm',
      fit: 'product'
    };
    var chartKey = root.getAttribute('data-chart-key') || 'gl001';
    var chart = CHARTS[chartKey] || CHARTS.gl001;
    var isApparelChart = root.getAttribute('data-chart-type') === 'apparel';

    var titleEl = root.querySelector('[data-gl-sg-title]');
    var lengthEl = root.querySelector('[data-gl-sg-length]');
    var tbody = root.querySelector('[data-gl-sg-tbody]');
    var apparelUnitEl = root.querySelector('[data-gl-sg-apparel-unit]');
    var fitLeadEl = root.querySelector('[data-gl-sg-fit-lead]');
    var productChartEl = root.querySelector('[data-gl-sg-product-chart]');
    var bodyChartEl = root.querySelector('[data-gl-sg-body-chart]');
    var apparelValueCells = [];
    var tabMen = root.querySelector('[data-gl-sg-gender="men"]');
    var tabWomen = root.querySelector('[data-gl-sg-gender="women"]');
    var btnCm = root.querySelector('[data-gl-sg-unit="cm"]');
    var btnIn = root.querySelector('[data-gl-sg-unit="in"]');

    function productLabel() {
      return canonicalProductName(
        root.getAttribute('data-product-name') || '',
        root.getAttribute('data-apparel-chart-id') || ''
      ) || (function () {
        var title = root.querySelector('.gl-sg__chart-title');
        return canonicalProductName(title ? title.textContent.replace(/\s*size chart\s*$/i, '').trim() : '', '');
      })();
    }

    function escapeAdvice(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function adviceMarkup(text) {
      return text.split('|').map(function (part, index) {
        var bits = part.split('→');
        if (bits.length < 2) {
          var cls = index === 0 ? 'gl-sg__advice-from' : 'gl-sg__advice-to';
          return '<span class="' + cls + '">' + escapeAdvice(part.trim()) + '</span>';
        }
        return '<span class="gl-sg__advice-from">' + escapeAdvice(bits[0].trim()) + '</span>' +
          '<span class="gl-sg__advice-arrow" aria-hidden="true">→</span>' +
          '<span class="gl-sg__advice-to">' + escapeAdvice(bits.slice(1).join('→').trim()) + '</span>';
      }).join('<span class="gl-sg__advice-sep" aria-hidden="true">|</span>');
    }

    function tagInchCells(table) {
      table.querySelectorAll('tr').forEach(function (row, rowIndex) {
        if (rowIndex === 0) return;
        row.querySelectorAll('td').forEach(function (cell, cellIndex) {
          if (cellIndex === 0) return;
          var value = cell.textContent.trim();
          if (/^-?\d+(?:\.\d+)?$/.test(value)) {
            cell.setAttribute('data-gl-inches', value);
            apparelValueCells.push(cell);
          }
        });
      });
    }

    var howEl = root.querySelector('[data-gl-sg-how]');

    function bindApparel() {
      apparelValueCells = [];
      if (!isApparelChart) return;
      var chartId = root.getAttribute('data-apparel-chart-id') || '';
      var canned = apparelPageById(chartId);
      if (canned && productChartEl) {
        productChartEl.innerHTML = canned.body;
        var brandSub = root.querySelector('.gl-sg__brand-sub');
        var titleNode = root.querySelector('.gl-sg__chart-title');
        var label = canonicalProductName(canned.title, canned.id);
        if (titleNode) titleNode.textContent = label + ' Size Chart';
        if (brandSub) brandSub.textContent = 'Size Guide · ' + label;
        var footerRight = root.querySelector('.gl-sg__footer-right');
        if (footerRight) footerRight.textContent = label;
      }
      if (bodyChartEl) {
        var bodyRows = BODY_CHARTS[productLabel()];
        var fitBar = root.querySelector('.gl-sg__fit');
        if (!bodyRows) {
          if (fitBar) fitBar.hidden = true;
          bodyChartEl.innerHTML = '';
        } else {
          if (fitBar) fitBar.hidden = false;
          var sizes = ['XS', 'S', 'M', 'L', 'XL'];
          var html = '<table><tbody><tr><td></td>' +
            sizes.map(function (size) { return '<td><strong>' + size + '</strong></td>'; }).join('') +
            '</tr>';
          bodyRows.forEach(function (row) {
            html += '<tr><td>' + row[0] + '</td>' +
              row[1].map(function (value) { return '<td>' + value + '</td>'; }).join('') +
              '</tr>';
          });
          html += '</tbody></table>';
          bodyChartEl.innerHTML = html;
        }
      }
      root.querySelectorAll('.gl-sg__apparel-content table').forEach(tagInchCells);
      if (howEl) {
        var isLower = /pant|trouser/i.test(productLabel());
        var upperImg = root.querySelector('[data-gl-sg-how-upper]');
        var lowerImg = root.querySelector('[data-gl-sg-how-lower]');
        if (upperImg) upperImg.hidden = isLower;
        if (lowerImg) lowerImg.hidden = !isLower;
        howEl.hidden = !(upperImg || lowerImg);
      }
    }

    bindApparel();

    var adviceEl = root.querySelector('[data-gl-sg-advice]');

    function isMensProduct() {
      var label = productLabel();
      if (/\bmen\b/i.test(label) && !/women/i.test(label)) return true;
      if (!isApparelChart && state.gender === 'men') return true;
      return false;
    }

    function syncAdvice() {
      if (!adviceEl) return;
      var adviceText = FIT_ADVICE[productLabel()];
      if (!adviceText || isMensProduct()) {
        adviceEl.hidden = true;
        adviceEl.innerHTML = '';
        return;
      }
      adviceEl.innerHTML = adviceMarkup(adviceText);
      adviceEl.hidden = false;
    }

    function render() {
      var isMen = state.gender === 'men';
      var isCm = state.unit === 'cm';
      var data = isMen ? chart.men : chart.women;

      if (titleEl) {
        titleEl.textContent = isMen ? "Men's Shoe Size Chart" : "Women's Shoe Size Chart";
      }
      if (lengthEl) {
        lengthEl.textContent = isCm ? 'Length (CM)' : 'Length (IN)';
      }
      if (tabMen) tabMen.classList.toggle('is-active', isMen);
      if (tabWomen) tabWomen.classList.toggle('is-active', !isMen);
      if (btnCm) btnCm.classList.toggle('is-active', isCm);
      if (btnIn) btnIn.classList.toggle('is-active', !isCm);
      var showBody = state.fit === 'body';
      root.querySelectorAll('[data-gl-sg-fit]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-gl-sg-fit') === state.fit);
      });
      if (productChartEl) productChartEl.hidden = showBody;
      if (bodyChartEl) bodyChartEl.hidden = !showBody;
      if (fitLeadEl) {
        fitLeadEl.textContent = showBody
          ? 'Body measurements that suit this piece.'
          : 'Garment measurements for this piece.';
      }
      syncAdvice();

      if (isApparelChart) {
        if (apparelUnitEl) apparelUnitEl.textContent = isCm ? 'CM' : 'inches';
        apparelValueCells.forEach(function (cell) {
          var inches = cell.getAttribute('data-gl-inches');
          cell.textContent = isCm ? (Number(inches) * 2.54).toFixed(1) : inches;
        });
      }

      if (tbody) {
        tbody.innerHTML = data
          .map(function (r) {
            var len = formatLength(r.cm, isCm ? 'cm' : 'in');
            return (
              '<tr>' +
              '<td class="gl-sg__td gl-sg__td--uk">' + r.uk + '</td>' +
              '<td class="gl-sg__td gl-sg__td--other">' + r.eu + '</td>' +
              '<td class="gl-sg__td gl-sg__td--other">' + r.us + '</td>' +
              '<td class="gl-sg__td gl-sg__td--other">' + len + '</td>' +
              '</tr>'
            );
          })
          .join('');
      }
    }

    root.querySelectorAll('[data-gl-sg-gender]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.gender = btn.getAttribute('data-gl-sg-gender');
        render();
      });
    });
    root.querySelectorAll('[data-gl-sg-unit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.unit = btn.getAttribute('data-gl-sg-unit');
        render();
      });
    });
    root.querySelectorAll('[data-gl-sg-fit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.fit = btn.getAttribute('data-gl-sg-fit');
        render();
      });
    });
    var pieceSelect = root.querySelector('[data-gl-sg-piece]');
    if (pieceSelect) {
      pieceSelect.addEventListener('change', function () {
        var option = pieceSelect.options[pieceSelect.selectedIndex];
        var nextId = pieceSelect.value;
        var nextName = option ? option.getAttribute('data-name') || option.text : '';
        root.setAttribute('data-apparel-chart-id', nextId);
        root.setAttribute('data-product-name', nextName);
        state.fit = 'product';
        bindApparel();
        render();
      });
    }

    function open() {
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('gl-sg-lock');
      var closeBtn = root.querySelector('[data-gl-sg-close]');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    function close() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('gl-sg-lock');
    }

    root.querySelectorAll('[data-gl-sg-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    root._glOpen = open;
    root._glClose = close;
    root._glSelectPiece = function (chartId) {
      if (!chartId) return;
      root.setAttribute('data-apparel-chart-id', chartId);
      root.setAttribute('data-product-name', CHART_ID_NAMES[chartId] || '');
      if (pieceSelect) pieceSelect.value = chartId;
      bindApparel();
      render();
    };
    render();
  }

  function initSelector(wrap) {
    if (!wrap || wrap.dataset.glSsReady) return;
    wrap.dataset.glSsReady = '1';

    var summary = wrap.querySelector('[data-gl-ss-summary]');
    var guideId = wrap.getAttribute('data-guide-id');
    var guide = guideId ? document.getElementById(guideId) : null;
    if (guide) initGuide(guide);

    function selectedLabel() {
      var checked = wrap.querySelector('input[type="radio"]:checked:not(.disabled)');
      return checked ? checked.value : '';
    }

    function cellText(el) {
      return (el && el.textContent ? el.textContent : '').replace(/\s+/g, ' ').trim();
    }

    function parseApparelChart(chartRoot) {
      var table = chartRoot && chartRoot.querySelector('.gl-sg__apparel-content table');
      if (!table) return null;
      var rows = Array.prototype.slice.call(table.querySelectorAll('tr'));
      if (rows.length < 2) return null;
      var head = Array.prototype.slice.call(rows[0].querySelectorAll('td, th'));
      if (head.length < 2) return null;
      var sizes = [];
      for (var i = 1; i < head.length; i++) {
        var sizeLabel = cellText(head[i]).toUpperCase();
        if (sizeLabel) sizes.push(sizeLabel);
      }
      var measures = [];
      for (var r = 1; r < rows.length; r++) {
        var cells = Array.prototype.slice.call(rows[r].querySelectorAll('td, th'));
        if (!cells.length) continue;
        var name = cellText(cells[0]).toUpperCase();
        if (!name) continue;
        var bySize = {};
        for (var c = 1; c < cells.length && c - 1 < sizes.length; c++) {
          bySize[sizes[c - 1]] = cellText(cells[c]);
        }
        measures.push({ name: name, bySize: bySize });
      }
      if (!sizes.length || !measures.length) return null;
      return { sizes: sizes, measures: measures };
    }

    function findMeasure(measures, needle) {
      for (var i = 0; i < measures.length; i++) {
        if (measures[i].name.indexOf(needle) !== -1) return measures[i];
      }
      return null;
    }

    function pickApparelMeasures(measures) {
      var chest = findMeasure(measures, 'CHEST');
      var waist = findMeasure(measures, 'WAIST');
      var length = findMeasure(measures, 'LENGTH');
      var picked = [];
      if (chest) picked.push(chest);
      else if (waist) picked.push(waist);
      if (length) picked.push(length);
      if (picked.length) return picked;
      return measures.slice(0, 2);
    }

    var spec = wrap.querySelector('[data-gl-ss-spec]');
    var specSize = wrap.querySelector('[data-gl-ss-spec-size]');
    var specMetrics = wrap.querySelector('[data-gl-ss-spec-metrics]');
    var specShirt = wrap.querySelector('[data-gl-ss-spec-icon="shirt"]');
    var specPants = wrap.querySelector('[data-gl-ss-spec-icon="pants"]');
    var apparelChart = parseApparelChart(guide);

    function syncSpec(label) {
      if (!spec || !specMetrics) return;
      var key = (label || '').toUpperCase();
      var measures = apparelChart ? pickApparelMeasures(apparelChart.measures) : [];
      var parts = [];
      measures.forEach(function (measure) {
        var value = measure.bySize[key];
        if (value) parts.push({ name: measure.name, value: value });
      });
      if (!key || !parts.length) {
        spec.hidden = true;
        specMetrics.textContent = '';
        return;
      }
      if (specSize) specSize.textContent = key;
      specMetrics.innerHTML = parts
        .map(function (part) {
          return (
            '<span class="gl-ss__spec-metric">' +
            part.name +
            ' ' +
            part.value +
            ' INCHES</span>'
          );
        })
        .join('');
      var usePants = parts.some(function (part) {
        return part.name.indexOf('WAIST') !== -1;
      }) && !parts.some(function (part) {
        return part.name.indexOf('CHEST') !== -1;
      });
      if (specShirt) specShirt.hidden = usePants;
      if (specPants) specPants.hidden = !usePants;
      spec.hidden = false;
    }

    function syncSummary() {
      var label = selectedLabel();
      wrap.querySelectorAll('.gl-ss__chip').forEach(function (chip) {
        var input = chip.querySelector('input');
        chip.classList.toggle('is-selected', !!(input && input.checked));
        chip.classList.toggle('is-soldout', !!(input && input.classList.contains('disabled')));
      });
      if (summary) {
        if (label) {
          summary.textContent = 'Selected Size: ' + label;
          summary.classList.remove('is-empty');
        } else {
          summary.textContent = '';
          summary.classList.add('is-empty');
        }
      }
      syncSpec(label);
    }

    wrap.addEventListener('change', syncSummary);
    syncSummary();

    function openGuide() {
      if (!guide) return;
      initGuide(guide);
      if (typeof guide._glOpen === 'function') guide._glOpen();
    }

    wrap.querySelectorAll('[data-gl-ss-open-guide]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openGuide();
      });
    });
  }

  function normalizeLegacyMirror(scope) {
    var leg = scope.querySelector('[data-size-ui="legacy"]');
    if (!leg || leg.dataset.glMirrorReady === '1') return;
    leg.dataset.glMirrorReady = '1';
    leg.querySelectorAll('select').forEach(function (sel) {
      sel.removeAttribute('disabled');
      /* Never attach form name on the mirror — new UI owns ATC options. */
      sel.removeAttribute('name');
    });
  }

  function bindSizeUiSync(scope) {
    var neu = scope.querySelector('[data-size-ui="new"]');
    var leg = scope.querySelector('[data-size-ui="legacy"]');
    if (!neu || !leg || neu.dataset.glSyncReady === '1') return;
    neu.dataset.glSyncReady = '1';

    var syncing = false;

    function findNewRadio(value) {
      var radios = neu.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === value) return radios[i];
      }
      return null;
    }

    function syncNewToLegacy(value) {
      if (syncing || !value) return;
      syncing = true;
      leg.querySelectorAll('select').forEach(function (sel) {
        var match = false;
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value === value) {
            match = true;
            break;
          }
        }
        if (match && sel.value !== value) {
          sel.value = value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      syncing = false;
    }

    function syncLegacyToNew(value) {
      if (syncing || !value) return;
      var radio = findNewRadio(value);
      if (!radio || radio.disabled || radio.classList.contains('disabled')) return;
      syncing = true;
      if (!radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('input', { bubbles: true }));
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncing = false;
    }

    neu.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) {
        syncNewToLegacy(e.target.value);
      }
    });

    leg.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('select')) {
        syncLegacyToNew(e.target.value);
      }
    });

    var checked = neu.querySelector('input[type="radio"]:checked');
    if (checked) syncNewToLegacy(checked.value);
  }

  function bindChartPreference(scope) {
    if (!scope || scope.dataset.glChartPreferenceReady === '1') return;
    scope.dataset.glChartPreferenceReady = '1';

    var useNewChart = scope.getAttribute('data-use-new-size-chart') !== 'false';

    scope.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var newTrigger = target.closest('[data-gl-ss-open-guide]');
      var legacyTrigger = target.closest('[data-legacy-size-chart-trigger]');

      if (useNewChart && legacyTrigger) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var guide = scope.querySelector('[data-gl-sg]');
        if (!guide) return;
        initGuide(guide);
        if (typeof guide._glOpen === 'function') guide._glOpen();
      } else if (!useNewChart && newTrigger) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var oldChartTrigger = scope.querySelector('[data-legacy-size-chart-trigger]');
        if (oldChartTrigger) oldChartTrigger.click();
      }
    }, true);
  }

  function bindKaraPageGuide() {
    var trigger = document.querySelector('[data-gl-kara-open-guide]');
    if (!trigger || trigger.dataset.glKaraReady === '1') return;
    trigger.dataset.glKaraReady = '1';
    var apparel = document.getElementById('GlKaraApparelGuide');
    var shoes = document.getElementById('GlKaraShoeGuide');
    if (apparel) initGuide(apparel);
    if (shoes) initGuide(shoes);
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      var active = document.querySelector('.gl-cat-nav button.active');
      var cat = active ? (active.getAttribute('data-cat') || 'ALL') : 'ALL';
      if (cat === 'shoes' && shoes && typeof shoes._glOpen === 'function') {
        shoes._glOpen();
        return;
      }
      if (!apparel || typeof apparel._glOpen !== 'function') return;
      var pieceId = PIECE_BY_CATEGORY[cat] || PIECE_BY_CATEGORY.ALL;
      if (typeof apparel._glSelectPiece === 'function') apparel._glSelectPiece(pieceId);
      apparel._glOpen();
    });
  }

  function boot() {
    document.querySelectorAll('[data-gl-ss]').forEach(initSelector);
    document.querySelectorAll('[data-gl-sg]').forEach(initGuide);
    document.querySelectorAll('[data-size-ui-controller]').forEach(function (scope) {
      normalizeLegacyMirror(scope);
      bindSizeUiSync(scope);
      bindChartPreference(scope);
    });
    bindKaraPageGuide();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
